import React, { useEffect, useState, useContext } from "react";

export const TechData = (props) => {

    return (
        <>
            {props.cultureCode === "en-us" &&

                <div className="contaniner-fluid" id="Technical-data">
                    <div className="header-section text-white text-center py-5"><h1 className="h1">Technical data</h1></div>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="row border-bottom mb-5 pb-5">
                                        <div className="col-md-9">
                                            <p>The top Certification</p>
                                            <p className="big">Yacht Safety Level</p>
                                            <p>(Ocean) yacht is a vessel that is built to navigate the open ocean and surpass a force 8 on the Beaufort scale and waves higher than 4 meters.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="valign">
                                                <div className="align-middle d-table-cell">
                                                    <div className="d-table mx-auto">
                                                        <span className="level">A</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row border-bottom mb-5 pb-5">
                                        <div className="col-md-4 text-center text-md-start">
                                            <p>Overall Lenght</p>
                                            <p className="big">23.70 m</p>
                                            <p>77' 9"</p>
                                        </div>
                                        <div className="col-md-4 text-center text-md-start">
                                            <p>Max Beam</p>
                                            <p className="big">6.36 m</p>
                                            <p>20' 10"</p>
                                        </div>
                                        <div className="col-md-4 text-center text-md-start">
                                            <p>Draft</p>
                                            <p className="big">1.92 m</p>
                                            <p>6' 4"</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-5">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Engines Configuration</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ color: '#FFFFFF' }} >STANDARD</span>
                                                    <p className="big">2 x MAN V8 1200 hp</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ color: '#FFFFFF' }} >OPTIONAL</span>
                                                    <p className="big">2 x MAN V12 1400 hp</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 pe-md-5">
                                            <p className="mb-5">STD Engine Performance<br /></p>

                                            <p className="mb-0"><small>Top Speed - Range</small></p>
                                            <p className="big">20 kn - 340 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label style={{ color: '#FFFFFF' }} >Speed</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '30%' }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Range</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Cruising Speed - Range</small></p>
                                            <p className="big">15 kn - 380 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '75%' }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Speed</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Range</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Eco Speed - Range</small></p>
                                            <p className="big">11 kn - 1000 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Speed</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Range</label>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6 pe-md-5">
                                            <p className="mb-5">OPT Engine Performance<br /></p>

                                            <p className="mb-0"><small>Top Speed - Range</small></p>
                                            <p className="big">22 kn - 320 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label style={{ color: '#FFFFFF' }} >Speed</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '25%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Range</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Cruising Speed - Range</small></p>
                                            <p className="big">17 kn - 360 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '85%' }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Speed</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '40%' }} aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Range</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Eco Speed - Range</small></p>
                                            <p className="big">11 kn - 1000 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Speed</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Range</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="contaniner-fluid" id="Technical-data">
                    <div className="header-section text-white text-center py-5"><h1 className="h1">Dati tecnici</h1></div>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="row border-bottom mb-5 pb-5">
                                        <div className="col-md-9">
                                            <p>Certificazione</p>
                                            <p className="big">Livello di Sicurezza</p>
                                            <p>Un’imbarcazione con categoria di progettazione A (Oceanica) è progettata per venti che possono superare forza 8 (Scala Beaufort) e un’altezza d’onda significativa superiore a 4 metri.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="valign">
                                                <div className="align-middle d-table-cell">
                                                    <div className="d-table mx-auto">
                                                        <span className="level">A</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row border-bottom mb-5 pb-5">
                                        <div className="col-md-4 text-center text-md-start">
                                            <p>LOA</p>
                                            <p className="big">23,70 m</p>
                                            <p>77' 9"</p>
                                        </div>
                                        <div className="col-md-4 text-center text-md-start">
                                            <p>Larghezza massima</p>
                                            <p className="big">6,36 m</p>
                                            <p>20' 10"</p>
                                        </div>
                                        <div className="col-md-4 text-center text-md-start">
                                            <p>Pescaggio</p>
                                            <p className="big">1,92 m</p>
                                            <p>6' 4"</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mb-5">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Motorizzazioni</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ color: '#FFFFFF' }} >STANDARD</span>
                                                    <p className="big">2 x MAN V8 1200 hp</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{ color: '#FFFFFF' }} >OPTIONAL</span>
                                                    <p className="big">2 x MAN V12 1400 hp</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 pe-md-5">
                                            <p className="mb-5">Performance Motorizzazione STD<br /></p>

                                            <p className="mb-0"><small>Velocità Max - Autonomia</small></p>
                                            <p className="big">20 kn - 340 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label style={{ color: '#FFFFFF' }} >Velocità</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '30%' }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Autonomia</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Velocità di Crociera - Autonomia</small></p>
                                            <p className="big">15 kn - 380 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '75%' }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Velocità</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Autonomia</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Crociera Economica - Autonomia</small></p>
                                            <p className="big">11 kn - 1000 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Velocità</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Autonomia</label>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6 pe-md-5">
                                            <p className="mb-5">Performance Motorizzazione OPT<br /></p>

                                            <p className="mb-0"><small>Velocità Max - Autonomia</small></p>
                                            <p className="big">22 kn - 320 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label style={{ color: '#FFFFFF' }} >Velocità</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '25%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Autonomia</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Velocità di Crociera - Autonomia</small></p>
                                            <p className="big">17 kn - 360 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '85%' }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Velocità</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '40%' }} aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Autonomia</label>
                                                </div>
                                            </div>

                                            <p className="mb-0"><small>Crociera Economica - Autonomia</small></p>
                                            <p className="big">11 kn - 1000 nm</p>
                                            <div className="range-container">
                                                <div className="progress">
                                                    <div className="progress-bar bg-ocean" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Velocità</label>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-beach" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                    <label>Autonomia</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );




};

export default TechData;